<header class="landing-a__navbar">
  <div class="landing-a__container landing-a__navbar-inner">
    <a class="landing-a__brand" routerLink="/landing-1" aria-label="Treeslo">
      <img class="landing-a__brand-logo" [src]="heroLogoSrc" alt="Treeslo" />
    </a>

    <nav class="landing-a__nav" [attr.aria-label]="'landing.landing_1.nav.aria_label' | translate">
      @for (link of navLinks; track link.key) {
        <a
          class="landing-a__nav-link"
          [href]="'#' + link.sectionId"
          (click)="scrollToSection(link.sectionId, $event)"
        >{{ 'landing.landing_1.nav.' + link.key | translate }}</a>
      }
    </nav>

    <div class="landing-a__navbar-actions">
      <app-landing-page-toolbar></app-landing-page-toolbar>
      <a class="landing-a__btn landing-a__btn--primary" [href]="dashboardUrl()">
        {{ 'landing.landing_1.nav.get_started' | translate }}
      </a>
    </div>
  </div>
</header>
